export const nav_items = [
  {
    id: 1,
    title: 'How it works',
    anchor: 'how-it-works',
  },
  {
    id: 2,
    title: 'Try it out',
    anchor: 'try-it-out',
  },
  {
    id: 3,
    title: 'Book a demo',
    anchor: 'contact-us',
  },
];
